import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { RideHistoryService } from '../ride-history.service';
import { RideHistoryActions } from './ride-history.actions';

@Injectable()
export class RideHistoryEpics implements RidangoEpic {
    constructor(private actions: RideHistoryActions, private service: RideHistoryService) {}

    register() {
        return [this.getRideHistory];
    }

    getRideHistory = (action$: ActionsObservable<any>) =>
        action$.ofType(RideHistoryActions.FETCH_RIDE_HISTORY).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { start, end, token } = action.payload;
                return this.service.fetchPurchaseHistory(start, end, token).pipe(
                    map((response) => this.actions.fetchRideHistorySuccess(response)),
                    catchError((error) => of(this.actions.fetchRideHistoryFail(error)))
                );
            })
        )
}
